import type * as type from "@vTypes";
import type { NurseResponse } from "@vTypes/nurse-type";

// 간호사 프리셉터 유틸
export function filterPreceptorList(
  fullNurseSchema: NurseResponse[],
  preceptorGroupID: type.PreceptorGroupID[]
) {
  if (fullNurseSchema.length > 0) {
    const allPrecepteeIds = preceptorGroupID.flatMap(
      (group) => group.preceptee
    );

    const sortedNurses = fullNurseSchema
      .slice() // 원본 배열 보존
      .filter((n) => n.preceptor_id === null)
      .filter((n) => !allPrecepteeIds.includes(n.nurse_id))
      .map((n) => ({
        nurse_id: n.nurse_id,
        name: n.name,
      }))
      .sort((a, b) => a.name.localeCompare(b.name, "ko")); // 한글 가나다 순 정렬
    return sortedNurses;
  }
}
